export default __webpack_public_path__ + "static/media/crowns.59c33f9a.png";